import { render } from "./CreateCard.vue?vue&type=template&id=231ad778&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=js"
export * from "./CreateCard.vue?vue&type=script&lang=js"

import "./CreateCard.vue?vue&type=style&index=0&id=231ad778&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231ad778"]])

export default __exports__